import { render, staticRenderFns } from "./AppNavbar.vue?vue&type=template&id=5bc04fb8"
import script from "./AppNavbar.vue?vue&type=script&lang=js"
export * from "./AppNavbar.vue?vue&type=script&lang=js"
import style0 from "./AppNavbar.vue?vue&type=style&index=0&id=5bc04fb8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports